import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appMenuFocusParent]'
})
export class MenuFocusParentDirective {
  @Output()
  readonly enterSubMenu = new EventEmitter<void>();

  constructor(private readonly elRef: ElementRef) {
  }

  focus(): void {
    this.elRef.nativeElement.focus();
  }

  @HostListener('keydown.arrowRight')
  onOpenMenu(): void {
    this.enterSubMenu.emit();
  }

  @HostListener('click', ['$event'])
  onClick(ev: MouseEvent): void {
    if(!this.isKeyboardEvent(ev)) {
      this.elRef.nativeElement.blur();
    }
  }

  private isKeyboardEvent(ev: MouseEvent): boolean {
    // hitting Space / Enter on focused element also emit MouseEvent
    return ev.screenX === 0 && ev.screenY === 0;
  }

}
